import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { ifProp, prop } from 'styled-tools';
import media from 'themes/media';

const Container = styled.section`
  background-color: #003765;
  z-index: 999;
  position: fixed;
  height: ${prop('height')}px;
  display: flex;
  flex-direction: column;
  width: 100%;
  right: 0;
  bottom: 0;
  top: 0;
  ${media.greaterThan('mobileL')`
    max-width: 380px;
  `}
`;

const Shadow = styled.div`
  display: none;
  ${media.greaterThan('mobileL')`
    display: block;
  `}
  position: absolute;
  right: 380px;
  width: 200px;
  bottom: 0;
  top: 0;
  background: linear-gradient(90deg, rgba(0, 25, 71, 0) 0%, #001947 100%);
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 999;
`;

const Header = styled.header`
  padding: 15px 20px;
  height: 60px;
  border-bottom: rgba(255, 255, 255, 0.15) 1px solid;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Main = styled.main`
  padding: 20px;
  flex-grow: 1;
  overflow: auto;
`;

const Footer = styled.footer`
  height: 69px;
  border-top: rgba(255, 255, 255, 0.15) 1px solid;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
`;

const Title = styled.p`
  visibility: visible;
  font-family: 'Untitled Sans', sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: -0.04em;
  color: white;
  ${media.greaterThan('mobileL')`
      visibility: hidden;
  `}
`;

const Grid = styled.div`
  display: grid;
  gap: 10px;
  grid-template-columns: 1fr 1fr;
`;

const ItemText = styled.p`
  font-weight: 400;
  font-size: 8px;
  line-height: 12px;
  text-align: center;
  text-transform: uppercase;
  position: absolute;
  top: 51px;
  left: 20px;
  right: 20px;
  color: white;
`;

const ItemIcon = styled.div`
  position: absolute;
  display: flex;
  color: #00a4af;
  bottom: 39px;
`;

const Item = styled(Link)`
  position: relative;
  border-radius: 10px;
  background: #001947;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
  width: 100%;
  color: white;

  :hover {
    ${ItemIcon} {
      color: white;
    }
    background-color: #00a4af;
    ${ItemText} {
      color: white;
    }
  }

  ${ifProp(
    'isActive',
    css`
      ${ItemIcon} {
        color: white;
      }
      background-color: #00a4af;
      ${ItemText} {
        color: white;
      }
    `
  )}
`;

const ItemBadge = styled.div`
  position: absolute;
  width: 16px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #00f47f;
  color: #003765;
  border-radius: 10px;
  top: 13px;
  z-index: 2;
  right: 65px;
  font-weight: 500;
  font-size: 10px;
  line-height: 16px;
  text-transform: uppercase;
`;

const Separator = styled.div`
  width: 100%;
  height: 1px;
  margin: 20px 0;
  background-color: rgba(255, 255, 255, 0.15);
`;

const LogoutBtn = styled.button`
  border: none;
  padding: 9px 15px;
  font-size: 8px;
  line-height: 12px;
  text-transform: uppercase;
  background: #215988;
  border-radius: 40px;
  color: white;
  cursor: pointer;
  :hover {
    opacity: 0.5;
  }
`;

const SelectTitle = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 8px;
  line-height: 12px;

  text-align: center;
  text-transform: uppercase;

  color: rgba(255, 255, 255, 0.6);
`;

const SelectWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  height: 20px;

  & button {
    height: auto;

    & span {
      margin-left: 5px;
    }
  }
`;

export {
  Container,
  Header,
  Title,
  Main,
  Footer,
  Grid,
  Separator,
  Item,
  ItemBadge,
  ItemIcon,
  ItemText,
  LogoutBtn,
  Shadow,
  Overlay,
  SelectTitle,
  SelectWrapper,
};
